package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLSelectElement

data class SelectOption(val value: String, val label: String)

/**
 * A dropdown of [options]; [placeholder] is shown and reported as `null` when nothing is chosen.
 */
@Composable
fun SelectField(
    options: List<SelectOption>,
    selected: String?,
    placeholder: String,
    onSelected: (String?) -> Unit,
    modifier: Modifier = Modifier,
) {
    Select({
        style {
            padding(0.5.cssRem)
            borderRadius(2.px)
            border {
                style = LineStyle.Solid
                width = 1.px
                color = rgb(176, 176, 176)
            }
        }
        // The `selected` attribute only sets the initial choice, so keep the live value in sync with state.
        prop({ element: HTMLSelectElement, value: String -> element.value = value }, selected.orEmpty())
        onChange { event -> onSelected(event.value?.takeIf { it.isNotEmpty() }) }
        modifier.toAttrs<org.jetbrains.compose.web.attributes.AttrsScope<org.w3c.dom.HTMLSelectElement>>().invoke(this)
    }) {
        Option("", { if (selected == null) selected() }) { Text(placeholder) }
        options.forEach { option ->
            Option(option.value, { if (option.value == selected) selected() }) { Text(option.label) }
        }
    }
}
